import React from "react";
import "../../Assets/Styles/pages/pickImage.scss";
import upload from "../../Assets/Images/feather-upload-cloud.svg";
import { useTranslation } from "react-i18next";
import { setExtension } from "../../Redux/DownloadSlice/downloadSlice";
import { setImageUrl } from "../../Redux/MainImage/imageSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import piexif from "piexifjs";
import helper_functions from "../../Config/helper_functions";
import {
  setCreate_Template,
  setEdit_Template,
} from "../../Redux/UserSlice/userSlice";

const PickImage = ({ setOpen }) => {
  const [dragging, setDragging] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const userSliceState = useSelector((state) => state["userSlice"]);

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const onFileChange = async (event) => {
    if (event.dataTransfer.files.length > 1) {
      alert("Only one image is allowed.");
      return;
    }
    var ext = event.dataTransfer.files[0];
    ext = helper_functions.isImageExtension(ext.name);

    if (!ext) {
      alert(t("NotSuportedFile"));
    } else {
      // ext = ext.type.toString().split('/')[1]
      var name = event.dataTransfer.files[0].name;

      var exifObj, base64;
      try {
        base64 = await convertBase64(event.dataTransfer.files[0]);
        exifObj = piexif.load(base64);
      } catch (error) {
        console.log("No metaData: ", error);
      }

      if (ext === "gif") ext = "jpeg";
      dispatch(setExtension(ext));
      dispatch(
        setImageUrl({
          url: base64,
          name: name,
          metadata: JSON.stringify(exifObj),
        })
      );
      if (userSliceState.edit_Template) {
        dispatch(setCreate_Template(true));
        dispatch(setEdit_Template(false));
      }
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    onFileChange(e);
    setDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };
  const handleDragOverEnd = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragOverEnd}
      className={`pickImage w_38 w_xl_30 px-4 pt-3 pb-4 ${
        userSliceState.edit_Template ? "pickImageTemplate" : null
      }  `}
    >
      <div
        className={`dashed_container mt-1 py-5 ${dragging && "draggingImage"}`}
        onClick={() => setOpen(true)}
      >
        <img alt="uplaod" src={upload} className="logo mt-4 mb-3" />

        <div className="upload_title productSansMedium text_18 mb-1">
          {t("lang.upload_title")}
        </div>
        <div className="upload_detail opacity-50 productSansLight mb-4 text_16">
          {t("lang.upload_detail")}
        </div>
      </div>
      {/* <Row className="mt-3 pt-2  justify-content-center align-items-center">
        <Col md={5} className="p-0 dark"></Col>
        <Col md={1} className="text-white CamptonExtraLight text_18">{t("lang.or")}</Col>
        <Col md={5} className="p-0 dark"></Col>
      </Row>
      <Row className="mt-3 d-flex justify-content-center align-items-center">
        <Col md={1} className="">
          <img src={otherApps} className="size_30x30 p-0" />
        </Col>
        <Col md={5} className="text-white CamptonExtraLight text_18">{t("lang.otherApps")}</Col> 
        </Row> */}
    </div>
  );
};

export default PickImage;
